//
import service from '../../utils/server'
export const getPersonInfo = data => {
    return service({
        url: '/fmUser/login',
        method: 'post',
        data
    })
};

export const fmUserChangeUserPwd = data => {
  return service({
    url: '/fmUser/editPwd',
    method: 'post',
    data
  })
};

// export const fmRoleUserData = data => {
//     return service({
//         url: '/fmRole/getRoleInfoByName',
//         method: 'post',
//         data
//     })
// };

export const fmRoleUserAddData = data => {
    return service({
        url: '/fmRole/addRole',
        method: 'post',
        data
    })
};

export const fmRoleUpdateData = data => {
    return service({
        url: '/fmRole/updateRole',
        method: 'post',
        data
    })
};

export const fmUserQueryList = data => {
    return service({
        url: '/fmUser/getUsersByNoOrName',
        method: 'post',
        data
    })
};

export const fmUserLogin = data => {
  return service({
    url: '/fmUser/login',
    method: 'post',
    data
  })
};

export const fmUserAutoLogin = data => {
  return service({
    url: '/fmUser/autoLogin',
    method: 'post',
    data
  })
};

export const getVerificationCode = data => {
  return service({
    url: '/fmUser/getVerificationCode',
    method: 'post',
    data
  })
};
//获取手机验证码
export const getSmsVerificationCode = data => {
  return service({
    url: '/fmUser/getSmsVerificationCode',
    method: 'post',
    data
  })
};
export const fmUserLoginOut = data =>{
  return service({
    url: '/fmUser/out',
    method: 'post',
    data
  })
}

export const dealerLogin = data => {
  return service({
    url: '/fm/otsToDealerLogin/dealerLogin',
    method: 'post',
    data
  })
};

export const queryPowerByMenuId = data => {
  return service({
    url: '/fmPageOp/queryPowerByMenuId',
    method: 'post',
    data
  })
};
export const systemNotice = data => {
  return service({
    url: '/fmUser/systemNotice',
    method: 'post',
    data
  })
};

//登录强制修改密码
export const loginForceUpdatePwd = data => {
  return service({
    url: '/fmUser/loginForceUpdatePwd',
    method: 'post',
    data
  })
};

//注销账号
export const fmUserLogOff = data => {
  return service({
    url: '/fmUser/logOff',
    method: 'post',
    data
  })
};

//找回账号
export const fmUserFindPwd = data => {
  return service({
    url: '/fmUser/findPwd',
    method: 'post',
    data
  })
};

//隐私协议
export const privacyAgreement = data => {
  return service({
    url: '/fmUser/privacyAgreement',
    method: 'post',
    data
  })
};

//授权信息
export const soldtoAuthorization = data => {
  return service({
    url: '/fmUser/soldtoAuthorization',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/view/api/ajax.js